import { useFormContext, useWatch } from 'react-hook-form';
import { ContributionFieldValues } from '../contributionPairs';
import { InvestmentFormValues } from '../types';

/** Watches the four contribution fields and returns them as a normalized {@link ContributionFieldValues}. */
export const useContributionFieldValues = (): ContributionFieldValues => {
  const { control } = useFormContext<InvestmentFormValues>();
  const incomeSourceID = useWatch({ control, name: 'incomeSourceID' });
  const percentage = useWatch({ control, name: 'recurringContributionPercentage' });
  const amount = useWatch({ control, name: 'recurringContribution.amount' });
  const frequency = useWatch({ control, name: 'recurringContribution.frequency' });

  return { incomeSourceID, percentage, amount, frequency };
};
